import { MappedClass, MappedProperty, MappedPropertyClass } from '@h5s/util-object';
import { ZPrinterHealthChecks } from './z-printer-health-checks';
import { ZPrinterHealthStatus } from './z-printer-health-status';

@MappedClass()
export class ZPrinterHealthResponse {
  @MappedPropertyClass(() => ZPrinterHealthChecks)
  checks?: ZPrinterHealthChecks;

  @MappedProperty()
  features?: string[];

  @MappedProperty()
  status?: ZPrinterHealthStatus;

  @MappedProperty()
  timestamp?: string;

  @MappedProperty()
  uptime?: string;

  @MappedProperty()
  version?: string;
}
